import { acceptHMRUpdate, defineStore } from "pinia";
import { useTargetStore } from "@editor/items/target/targets.store";
import type { Uid } from "@/helpers/utility/Id";


export const useModelViewStore = defineStore("model/modelView", {
  state: () => ({
    flowSourceElement: null as null | { uid: Uid<"target" | "resource"> },
    impactSourceElement: null as null | { uid: Uid<"target" | "resource" | "index"> },
  }),
  getters: {
    /**
     * Contains the current value of each simulation, based on its last round.
     * The value is calculated based on the value of each target.
     */
    value() {
      const targetStore = useTargetStore();
      const targets = targetStore.orderedItems;

      if (targets.length === 0) return 0;
      return (
        targets.reduce((sum, target) => sum + target.value, 0) /
        targets.length
      );
    }
  },
  actions: {
    set(options: object) {
      this.$patch((state) => {
        Object.assign(state, options);
      });
    }
  }
});

if (import.meta.hot) {
  import.meta.hot.accept(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    acceptHMRUpdate(useModelViewStore as any, import.meta.hot)
  );
}
